module.exports = __webpack_public_path__ + "img/34_39.ee60d96d.png";